import { render, staticRenderFns } from "./ModalAPGroup.vue?vue&type=template&id=2f222786&scoped=true&"
import script from "./ModalAPGroup.vue?vue&type=script&lang=js&"
export * from "./ModalAPGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f222786",
  null
  
)

export default component.exports